// extracted by mini-css-extract-plugin
export var banner = "_or-0";
export var settingRow = "_or-2";
export var titleIcon = "_or-1";